import { Fragment } from 'react';

import { Button } from '@com/_atoms/NewButton';
import Icon from '@utilities/icon';
import { colorPallete } from '@configs/color-pallete';
import Divider from '@com/_atoms/Divider';
import useModal from '@hooks/useModal';
import { DoctorClinicItemModel } from '@models/in-person-booking';
import { useGetDoctorClinic } from '@api/in-person-booking/index.rq';
import useInView from '@hooks/useInView';
import OfficeLocationBottomSheet from '@com/shared/office-location-bottom-sheet';

import OfficeContactBottomSheet from './office-contact-bottom-sheet';

type OfficeDetailProps = {
  doctorId: string;
  docorName: string;
};

const OfficeDetail = ({ doctorId, docorName }: OfficeDetailProps) => {
  const { addModal } = useModal();

  const { ref, isInView } = useInView();

  const { data: clinicData } = useGetDoctorClinic(
    {
      doctorId: String(doctorId),
    },
    {
      enabled: !!doctorId && isInView,
    },
  );

  const handleOpenLocationBottomSheet = (item: DoctorClinicItemModel) => {
    addModal({
      modal: OfficeLocationBottomSheet,
      props: {
        latitude: item?.latitude,
        longitude: item?.longitude,
        officeId: item?.id,
        officeName: item?.title,
      },
    });
  };

  const handleOpenContactBottomSheet = (item: DoctorClinicItemModel) => {
    addModal({
      modal: OfficeContactBottomSheet,
      props: {
        latitude: item?.latitude,
        longitude: item?.longitude,
        officeName: item?.title,
        phoneNumber: item?.primaryNumber ?? item?.secondaryNumber ?? '',
        doctorName: docorName,
      },
    });
  };

  if (!clinicData?.data?.length) {
    return (
      <div className="flex flex-col gap-y-4" ref={ref}>
        <div className="h-full w-full flex items-center px-4 text-Label/Medium text-content-primary">
          اطلاعات مطب
        </div>

        <span className="text-content-tertiary text-Label/xSmall px-4">
          اطلاعات مطب ثبت نشده است
        </span>
      </div>
    );
  }

  return (
    <div className="flex flex-col gap-y-4" ref={ref}>
      <div className="h-full w-full flex items-center px-4 text-Label/Medium text-content-primary">
        اطلاعات مطب
      </div>

      <div className="flex flex-col gap-y-2">
        {clinicData?.data?.map((item, index) => (
          <Fragment key={item?.id}>
            <div className="flex flex-col py-1 px-4 gap-y-3" key={item?.id}>
              <div className="w-full flex items-center justify-between gap-x-2">
                <div className="text-content-tertiary text-Label/xSmall">
                  <span className="text-Label/Small text-content-primary">
                    {item?.title} :
                  </span>{' '}
                  {item?.clinicAddress}
                </div>

                <Button
                  variant="ghost"
                  iconPosition="right"
                  size="small"
                  icon={
                    <Icon
                      name="DiamondArrowTurnRight"
                      width={1.25}
                      height={1.25}
                      fill={colorPallete?.content?.accent}
                    />
                  }
                  onClick={() => handleOpenLocationBottomSheet(item)}
                  className="gap-1"
                >
                  مسیریابی
                </Button>
              </div>

              <div className="flex items-center justify-between">
                <span className="text-Label/Small text-content-primary">
                  تلفن مطب :
                </span>

                <Button
                  variant="ghost"
                  size="small"
                  onClick={() => handleOpenContactBottomSheet(item)}
                >
                  نمایش شماره تلفن
                </Button>
              </div>
            </div>

            {clinicData?.data?.length !== index && (
              <Divider className="h-[1px]" />
            )}
          </Fragment>
        ))}
      </div>
    </div>
  );
};

export default OfficeDetail;
